/*
 *  I01EVACONSSYSTECSCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-02 18:09:18 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchLogementCompositionECS } from '@batical/data/src'
import { I01EVACONSSYSTECS_State } from '@batical/types/src'

const puissSemiAccumuleFactor: Array<{ key: number; value: number }> = [
  { key: 83, value: 0.708 },
  { key: 108, value: 0.773 },
  { key: 116, value: 0.815 },
  { key: 162, value: 0.789 },
  { key: 189, value: 0.784 },
  { key: 241, value: 0.758 },
  { key: 277, value: 0.75 },
  { key: 294, value: 0.762 }
]

function I01EVACONSSYSTECS_docalcul(state: I01EVACONSSYSTECS_State) {
  state.res_totalLogementStandard = 0
  state.res_puissanceSemiECS = 0
  state.res_debit_dtu = 0
  state.res_puissanceAppoint = 0
  if (state.in_typeLogement === '0' || state.in_typeLogement === '2') {
    state.res_totalLogementStandard += state.in_t1_Ddo * fetchLogementCompositionECS('1').coeffSocial
    state.res_totalLogementStandard += state.in_t1_ba * fetchLogementCompositionECS('2').coeffSocial
    state.res_totalLogementStandard += state.in_t2_do * fetchLogementCompositionECS('3').coeffSocial
    state.res_totalLogementStandard += state.in_t2_ba * fetchLogementCompositionECS('4').coeffSocial
    state.res_totalLogementStandard += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').coeffSocial
    state.res_totalLogementStandard += state.in_t3_ba_do * fetchLogementCompositionECS('6').coeffSocial
    state.res_totalLogementStandard += state.in_t4_ba * fetchLogementCompositionECS('7').coeffSocial
    state.res_totalLogementStandard += state.in_t4_ba_do * fetchLogementCompositionECS('8').coeffSocial
    state.res_totalLogementStandard += state.in_t56_ba * fetchLogementCompositionECS('9').coeffSocial
    state.res_totalLogementStandard += state.in_t56_ba_do * fetchLogementCompositionECS('10').coeffSocial
    state.res_totalLogementStandard += state.in_T56_2ba * fetchLogementCompositionECS('11').coeffSocial
  } else {
    state.res_totalLogementStandard += state.in_t1_Ddo * fetchLogementCompositionECS('1').coeffPrive
    state.res_totalLogementStandard += state.in_t1_ba * fetchLogementCompositionECS('2').coeffPrive
    state.res_totalLogementStandard += state.in_t2_do * fetchLogementCompositionECS('3').coeffPrive
    state.res_totalLogementStandard += state.in_t2_ba * fetchLogementCompositionECS('4').coeffPrive
    state.res_totalLogementStandard += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').coeffPrive
    state.res_totalLogementStandard += state.in_t3_ba_do * fetchLogementCompositionECS('6').coeffPrive
    state.res_totalLogementStandard += state.in_t4_ba * fetchLogementCompositionECS('7').coeffPrive
    state.res_totalLogementStandard += state.in_t4_ba_do * fetchLogementCompositionECS('8').coeffPrive
    state.res_totalLogementStandard += state.in_t56_ba * fetchLogementCompositionECS('9').coeffPrive
    state.res_totalLogementStandard += state.in_t56_ba_do * fetchLogementCompositionECS('10').coeffPrive
    state.res_totalLogementStandard += state.in_T56_2ba * fetchLogementCompositionECS('11').coeffPrive
  }
  state.res_totalLogementStandard = Math.round(state.res_totalLogementStandard * 1000) / 1000
  state.res_consJour = 0
  //let factor: number = (40.0 - state.in_tempFroid) / (state.in_tempChaude - state.in_tempFroid);
  //FIX 2.5.0
  let factor: number = (0.6 * (state.in_tempChaude - state.in_tempFroid)) / 50
  if (state.in_typeLogement === '0' || state.in_typeLogement === '1') {
    state.res_consJour = state.res_totalLogementStandard * 70
  } else if (state.in_typeLogement === '2') {
    state.res_consJour += state.in_t1_Ddo * fetchLogementCompositionECS('1').social40 * factor
    state.res_consJour += state.in_t1_ba * fetchLogementCompositionECS('2').social40 * factor
    state.res_consJour += state.in_t2_do * fetchLogementCompositionECS('3').social40 * factor
    state.res_consJour += state.in_t2_ba * fetchLogementCompositionECS('4').social40 * factor
    state.res_consJour += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').social40 * factor
    state.res_consJour += state.in_t3_ba_do * fetchLogementCompositionECS('6').social40 * factor
    state.res_consJour += state.in_t4_ba * fetchLogementCompositionECS('7').social40 * factor
    state.res_consJour += state.in_t4_ba_do * fetchLogementCompositionECS('8').social40 * factor
    state.res_consJour += state.in_t56_ba * fetchLogementCompositionECS('9').social40 * factor
    state.res_consJour += state.in_t56_ba_do * fetchLogementCompositionECS('10').social40 * factor
    state.res_consJour += state.in_T56_2ba * fetchLogementCompositionECS('11').social40 * factor
  } else if (state.in_typeLogement === '3') {
    state.res_consJour += state.in_t1_Ddo * fetchLogementCompositionECS('1').prive40 * factor
    state.res_consJour += state.in_t1_ba * fetchLogementCompositionECS('2').prive40 * factor
    state.res_consJour += state.in_t2_do * fetchLogementCompositionECS('3').prive40 * factor
    state.res_consJour += state.in_t2_ba * fetchLogementCompositionECS('4').prive40 * factor
    state.res_consJour += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').prive40 * factor
    state.res_consJour += state.in_t3_ba_do * fetchLogementCompositionECS('6').prive40 * factor
    state.res_consJour += state.in_t4_ba * fetchLogementCompositionECS('7').prive40 * factor
    state.res_consJour += state.in_t4_ba_do * fetchLogementCompositionECS('8').prive40 * factor
    state.res_consJour += state.in_t56_ba * fetchLogementCompositionECS('10').prive40 * factor
    state.res_consJour += state.in_t56_ba_do * fetchLogementCompositionECS('10').prive40 * factor
    state.res_consJour += state.in_T56_2ba * fetchLogementCompositionECS('11').prive40 * factor
  }
  state.res_consoHPointe = 83 * Math.pow(state.res_totalLogementStandard, 0.708)
  state.res_conso10mn = 61 * Math.pow(state.res_totalLogementStandard, 0.503)
  if (state.in_typeCalcul === 0) {
    state.res_puissanceThermique = (1.163 * state.res_conso10mn * (state.in_tempChaude - state.in_tempFroid) * 6) / 900
    state.res_maxVolStackagECS = 294 * Math.pow(state.res_totalLogementStandard, 0.762)
    if (state.in_VolStockageECS > state.res_maxVolStackagECS) {
      state.in_VolStockageECS = Number(state.res_maxVolStackagECS.toFixed(2))
    }
    if (state.in_VolStockageECS > 0) {
      var puissanceHaute = 0
      var puissanceBasse = state.res_puissanceThermique
      var conditionPrevious = 0
      var conditionLimite = 0
      var counter = 0
      var backupH4 = 0
      state.res_puissanceSemiECS = state.res_puissanceThermique
      while (conditionLimite <= state.in_VolStockageECS && counter < puissSemiAccumuleFactor.length) {
        puissanceHaute = puissanceBasse
        conditionPrevious = conditionLimite
        const puissFcteur = puissSemiAccumuleFactor[counter]
        conditionLimite = puissFcteur.key * Math.pow(state.res_totalLogementStandard, puissFcteur.value)
        counter += 1
        puissanceBasse = ((conditionLimite / counter) * (state.in_tempChaude - state.in_tempFroid) * 1.163) / 1000
        if (counter === 1) {
          backupH4 = puissanceBasse
        }
      }
      if (conditionLimite <= state.in_VolStockageECS && counter === puissSemiAccumuleFactor.length) {
        state.res_puissanceSemiECS = 0
      }

      state.res_puissanceSemiECS =
        ((puissanceHaute - puissanceBasse) * (conditionLimite - state.in_VolStockageECS)) / (conditionLimite - conditionPrevious) +
        puissanceBasse
      if (state.res_totalLogementStandard <= 20) {
        state.res_puissanceSemiECS = Math.max(state.res_puissanceSemiECS, backupH4)
      }
      state.res_puissanceSemiECS = state.res_puissanceSemiECS / 0.9
    } else {
      state.res_puissanceSemiECS = 0
    }
  } else {
    state.res_puissanceThermique = 0
    var tempfactor = (state.in_tempChaude - state.in_tempFroid) / (state.in_tempStockagePrimaire - state.in_tempRetourEchangeur)
    state.res_maxVolStackagECS = 294 * Math.pow(state.res_totalLogementStandard, 0.762)

    //evier
    var tempCalc = state.in_t1_Ddo * fetchLogementCompositionECS('1').nb_evier
    tempCalc += state.in_t1_ba * fetchLogementCompositionECS('2').nb_evier
    tempCalc += state.in_t2_do * fetchLogementCompositionECS('3').nb_evier
    tempCalc += state.in_t2_ba * fetchLogementCompositionECS('4').nb_evier
    tempCalc += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').nb_evier
    tempCalc += state.in_t3_ba_do * fetchLogementCompositionECS('6').nb_evier
    tempCalc += state.in_t4_ba * fetchLogementCompositionECS('7').nb_evier
    tempCalc += state.in_t4_ba_do * fetchLogementCompositionECS('8').nb_evier
    tempCalc += state.in_t56_ba * fetchLogementCompositionECS('9').nb_evier
    tempCalc += state.in_t56_ba_do * fetchLogementCompositionECS('10').nb_evier
    tempCalc += state.in_T56_2ba * fetchLogementCompositionECS('11').nb_evier
    var debitBrut = tempCalc
    var debitTotal = tempCalc * 0.133
    //vasque
    tempCalc = state.in_t1_Ddo * fetchLogementCompositionECS('1').nb_vasque
    tempCalc += state.in_t1_ba * fetchLogementCompositionECS('2').nb_vasque
    tempCalc += state.in_t2_do * fetchLogementCompositionECS('3').nb_vasque
    tempCalc += state.in_t2_ba * fetchLogementCompositionECS('4').nb_vasque
    tempCalc += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').nb_vasque
    tempCalc += state.in_t3_ba_do * fetchLogementCompositionECS('6').nb_vasque
    tempCalc += state.in_t4_ba * fetchLogementCompositionECS('7').nb_vasque
    tempCalc += state.in_t4_ba_do * fetchLogementCompositionECS('8').nb_vasque
    tempCalc += state.in_t56_ba * fetchLogementCompositionECS('9').nb_vasque
    tempCalc += state.in_t56_ba_do * fetchLogementCompositionECS('10').nb_vasque
    tempCalc += state.in_T56_2ba * fetchLogementCompositionECS('11').nb_vasque
    debitBrut += tempCalc
    debitTotal += tempCalc * 0.133
    //douche
    tempCalc = 0
    tempCalc = state.in_t1_Ddo * fetchLogementCompositionECS('1').nb_douche
    tempCalc += state.in_t1_ba * fetchLogementCompositionECS('2').nb_douche
    tempCalc += state.in_t2_do * fetchLogementCompositionECS('3').nb_douche
    tempCalc += state.in_t2_ba * fetchLogementCompositionECS('4').nb_douche
    tempCalc += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').nb_douche
    tempCalc += state.in_t3_ba_do * fetchLogementCompositionECS('6').nb_douche
    tempCalc += state.in_t4_ba * fetchLogementCompositionECS('7').nb_douche
    tempCalc += state.in_t4_ba_do * fetchLogementCompositionECS('8').nb_douche
    tempCalc += state.in_t56_ba * fetchLogementCompositionECS('9').nb_douche
    tempCalc += state.in_t56_ba_do * fetchLogementCompositionECS('10').nb_douche
    tempCalc += state.in_T56_2ba * fetchLogementCompositionECS('11').nb_douche
    debitBrut += tempCalc
    debitTotal += tempCalc * 0.133
    //baignoe
    tempCalc = 0
    tempCalc = state.in_t1_Ddo * fetchLogementCompositionECS('1').nb_baignoire
    tempCalc += state.in_t1_ba * fetchLogementCompositionECS('2').nb_baignoire
    tempCalc += state.in_t2_do * fetchLogementCompositionECS('3').nb_baignoire
    tempCalc += state.in_t2_ba * fetchLogementCompositionECS('4').nb_baignoire
    tempCalc += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').nb_baignoire
    tempCalc += state.in_t3_ba_do * fetchLogementCompositionECS('6').nb_baignoire
    tempCalc += state.in_t4_ba * fetchLogementCompositionECS('7').nb_baignoire
    tempCalc += state.in_t4_ba_do * fetchLogementCompositionECS('8').nb_baignoire
    tempCalc += state.in_t56_ba * fetchLogementCompositionECS('9').nb_baignoire
    tempCalc += state.in_t56_ba_do * fetchLogementCompositionECS('10').nb_baignoire
    tempCalc += state.in_T56_2ba * fetchLogementCompositionECS('11').nb_baignoire
    debitBrut += tempCalc
    debitTotal += tempCalc * 0.33
    var debitProbable = (0.8 / Math.sqrt(debitBrut - 1)) * debitTotal

    state.res_puissanceThermique = debitProbable * 3.6 * 1.163 * (state.in_tempChaude - state.in_tempFroid)
    state.res_debit_dtu = debitProbable * 60
    if (state.in_volumStockageAppoint > state.res_maxVolStackagECS * tempfactor) {
      state.in_volumStockageAppoint = Number((state.res_maxVolStackagECS * tempfactor).toFixed(2))
    }
    state.res_maxPuissanceAppoint = Number((state.res_maxVolStackagECS * tempfactor).toFixed(2))
    if (state.in_volumStockageAppoint > 0) {
      puissanceHaute = 0
      puissanceBasse = (1.163 * state.res_conso10mn * (state.in_tempChaude - state.in_tempFroid) * 6) / 900
      conditionPrevious = 0
      conditionLimite = 0
      counter = 0
      backupH4 = 0
      state.res_puissanceAppoint = (1.163 * state.res_conso10mn * (state.in_tempChaude - state.in_tempFroid) * 6) / 900

      var volCondition = state.in_volumStockageAppoint / tempfactor
      while (conditionLimite <= volCondition && counter < puissSemiAccumuleFactor.length) {
        puissanceHaute = puissanceBasse
        conditionPrevious = conditionLimite
        const puissFcteur = puissSemiAccumuleFactor[counter]
        conditionLimite = puissFcteur.key * Math.pow(state.res_totalLogementStandard, puissFcteur.value)
        counter += 1
        puissanceBasse = ((conditionLimite / counter) * (state.in_tempChaude - state.in_tempFroid) * 1.163) / 1000
        if (counter === 1) {
          backupH4 = puissanceBasse
        }
      }
      state.res_puissanceAppoint =
        (((puissanceHaute - puissanceBasse) * (conditionLimite - volCondition)) / (conditionLimite - conditionPrevious) + puissanceBasse) /
        0.9
    } else {
      state.res_puissanceAppoint = 0
    }
    state.in_volumStockageAppoint = Math.max(0, state.in_volumStockageAppoint)
  }
  //section 3

  //mode primaire
  state.invalidated = false
  return state
}

export default I01EVACONSSYSTECS_docalcul
